import React, { FC, useMemo } from "react";
import GeniusFeedsLogo from "../../assets/ads/genius-logo.svg";

interface AdDisplayProps {
  adImages?: string[];
  customClassName?: string;
}

export const AdDisplay: FC<AdDisplayProps> = ({
  adImages = [GeniusFeedsLogo],
  customClassName,
}) => {
  const processedImages = useMemo(() => {
    const minLength = 20;
    if (adImages.length >= minLength) {
      return adImages;
    }

    const repeatCount = Math.ceil(minLength / adImages.length);
    const repeatedImages = Array(repeatCount)
      .fill(adImages)
      .flat()
      .slice(0, minLength);

    return repeatedImages;
  }, [adImages]);

  const containerClasses = [
    "absolute left-1/2 top-[25%] h-[4.8vw] md:h-[3vw] w-[73%] -translate-x-1/2 transform flex items-center rounded-t overflow-hidden z-[999]",
    "bg-transparent pointer-events-none",
    customClassName,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={containerClasses}>
      <div className="flex w-max items-center justify-center gap-[3vw] md:gap-[2vw] animate-[adInfiniteScroll_30s_linear_infinite] will-change-transform">
        {processedImages.map((src, index) => (
          <img
            key={`${src}-${index}`}
            src={src}
            alt={`Ad ${index + 1}`}
            className="h-[4.2vw] md:h-[2.6vw] w-auto max-w-none object-contain mx-[1.2vw] md:mx-[1vw]"
            draggable={false}
          />
        ))}
      </div>
    </div>
  );
};
export default AdDisplay;
